import React, { useCallback } from 'react';

import { twMerge } from 'tailwind-merge';

import type { IconProps } from 'components-new/icon/icon';
import Icon from 'components-new/icon/icon';
import Typography from 'components-new/typography/typography';

export interface RadioButtonItemProps {
  id: string;
  active: boolean;
  onClick: (id: string) => void;
  leftIconProps?: IconProps;
  label?: string;
  className?: string;
}

const RadioButtonItem: React.FC<RadioButtonItemProps> = ({
  id,
  active,
  onClick,
  leftIconProps,
  label,
  className,
}) => {
  const buttonItemClassName = twMerge(
    'flex items-center justify-center gap-1 px-3 py-1 rounded-lg',
    'transition-transform duration-600 ease-in-out',
    active && 'bg-white text-primary-400',
    !active && 'text-gray400 hover:text-gray600',
    'focus-visible:outline-none focus-visible:ring-0 focus-visible:shadow focus-visible:text-primary-400',
    className,
  );

  const onButtonClick = useCallback(() => onClick(id), [id, onClick]);

  return (
    <button
      type="button"
      aria-pressed={active}
      className={buttonItemClassName}
      onClick={onButtonClick}
    >
      {leftIconProps && <Icon size={20} {...leftIconProps} />}
      {label && (
        <Typography variant="ui-nav-sub" as="span">
          {label}
        </Typography>
      )}
    </button>
  );
};

export default RadioButtonItem;
